import { AppDispatch, GetAppState, ExtraArgument } from "../store";
import * as actions from "../slices/session";
import { Error as APIError, OrganizationWithUserContext, User } from "../../types/apiv1";

export const login = (email: string, password: string) =>
	async (dispatch: AppDispatch, getState: GetAppState, { api }: ExtraArgument) => {
		dispatch(actions.pending());

		let me: User;
		let organizations: OrganizationWithUserContext[];
		try {
			await api.auth.login(email, password);
			me = await api.users.me.get();
			organizations = await api.users.me.organizations();
		} catch (e) {
			switch (e) {
			case APIError.Network:
				dispatch(actions.logout(actions.RejectionReason.Network));
				return;
			case APIError.Forbidden:
				dispatch(actions.logout(actions.RejectionReason.BadCredentials));
				return;
			default:
				console.error(e);
				dispatch(actions.logout(actions.RejectionReason.Bug));
				return;
			}
		}

		dispatch(actions.login({ me, organizations }));
	};

export const logout = () =>
	async (dispatch: AppDispatch, getState: GetAppState, { api, navigate }: ExtraArgument) => {
		const state = getState();

		if (!state.session.authenticated)
			throw new Error("can't logout when not already logged in!");

		try {
			await api.auth.logout();
		} catch (e) {
			dispatch(actions.logout(actions.RejectionReason.ExternalLogout));
			return;
		}

		dispatch(actions.logout(actions.RejectionReason.Logout));

		// Make sure that we are at the root when logging out naturally.
		// This is so that if the user logs in as another user with different
		// permissions they won't be greated with a forbidden error.
		navigate("/");
	};

export const refreshOrganizations = () =>
	async (dispatch: AppDispatch, getState: GetAppState, { api, navigate }: ExtraArgument) => {
		let organizations: OrganizationWithUserContext[];

		try {
			organizations = await api.users.me.organizations();
		} catch (e) {
			// TODO: display error toast
			return;
		}

		dispatch(actions.refreshOrganizations(organizations));
	};

export const changeToNewOrganization = (changeTo: string, navigateTo?: string) =>
	async (dispatch: AppDispatch, getState: GetAppState, { api, navigate }: ExtraArgument) => {
		let organizations: OrganizationWithUserContext[];

		try {
			organizations = await api.users.me.organizations();
		} catch (e) {
			// TODO: display error toast
			return;
		}

		dispatch(actions.refreshOrganizations(organizations));
		dispatch(actions.changeOrganization(changeTo));
		if (navigateTo !== undefined) {
			navigate(navigateTo);
		}
	};
